import { Event } from '../event';

export const getRedirectUrlToPromotionalWebsite = (
    event: Event,
    search = '',
    isEventExperienceSummitEvent?: boolean
): string => {
    if (isEventExperienceSummitEvent) {
        return 'https://events.bizzabo.com/eventexperience/page/2163319/gamification';
    }

    const eventGroupId = event?.groupId;
    const eventGroupIdParam = eventGroupId ? `&eventGroupId=${eventGroupId}` : '';
    return `/redirect?url=${event?.homepageUrl}${search}${eventGroupIdParam}`;
};

export const redirectToPromotionalWebsite = (event: Event, search?: string): void => {
    window.location.href = getRedirectUrlToPromotionalWebsite(event, search);
};

let promoWebsiteWindowRef = null;
type OpenPromotionalWebsiteInNewTab = (
    event: Event,
    isEventExperienceSummitEvent?: boolean
) => void;

export const openPromotionalWebsiteInNewTab: OpenPromotionalWebsiteInNewTab = (
    event,
    isEventExperienceSummitEvent
): void => {
    const url = getRedirectUrlToPromotionalWebsite(event, '', isEventExperienceSummitEvent);

    if (promoWebsiteWindowRef === null || promoWebsiteWindowRef.closed) {
        promoWebsiteWindowRef = window.open(url, '_blank');
    } else {
        promoWebsiteWindowRef.location = url;
        promoWebsiteWindowRef.focus();
    }
};
